import fetchJson from "@/lib/fetchJson";
import useSWR from "swr";
import { isValidNumericId } from "@/lib/util";

export const useArtists = () => useSWR<Artist[]>(`/artist/`, fetchJson);

export const useSongs = (artistId: number | undefined) => {
  console.log('artist')
  return useSWR<Artist>(isValidNumericId(artistId) ? `/artist/${artistId}` : null, fetchJson);
};

export const deleteSong = async (id: number) =>
  fetchJson(`/artist/song/${id}`, {
    method: "DELETE",
  });

export const deleteArtist = async (id: number) =>
  fetchJson(`/artist/${id}`, {
    method: "DELETE",
  });

export const createArtist = async (
  name: string,
  spotifyLink: any,
  type?: "artist" | "brand"
) =>
  fetchJson(`/artist/`, {
    method: "POST",
    body: JSON.stringify({
      name,
      ...(type === "brand" ? { type: "brand" } : { type: "artist" }),
      ...(type === "brand"
        ? {}
        : {
            spotifyId: spotifyLink?.value?.id,
            spotifyLoginId: spotifyLink?.value?.spotifyId,
          }),
    }),
  });

export const createSong = async (id: number, name: string) =>
  fetchJson(`/artist/song/${id}`, {
    method: "POST",
    body: JSON.stringify({ name }),
  });
